import React from 'react';
import { InputWrapper } from './styles';
import { useTagSearchResults } from '@hooks/features/useStockSearch';
import { ModeContext } from '@/contexts/ModeContext';
import { SelectableTagResults } from './SelectableTagResults';
import { useBlurAction } from '@hooks/function/useBlurAction';

export const TagSearchInput = ({ forwardRef, enableCreateTag, onAddTag, placeholder }) => {
  const modeContext = React.useContext(ModeContext);

  const [textInputHasFocus, setTextInputHasFocus] = React.useState(false);

  const [textInputValue, setTextInputValue] = React.useState('');
  const [isQuerying, selectableTags, activeQuery] = useTagSearchResults(textInputValue, modeContext);

  const showTagSearchResults = textInputHasFocus && activeQuery === textInputValue;

  const { queueDelayedBlur, clearDelayedBlur } = useBlurAction();

  const handleTextChange = (e) => {
    const value = e.target.value;
    if (value === ' ' && textInputValue === '') {
      return;
    }
    setTextInputValue(value);
  };

  const handleAddTag = (tag) => {
    onAddTag(tag);
    setTextInputValue('');
    forwardRef?.current?.focus();
  };

  const onTextInputFocus = () => {
    setTextInputHasFocus(true);
    clearDelayedBlur();
  };

  const onTextInputBlur = () => {
    queueDelayedBlur(() => setTextInputHasFocus(false));
  };

  return (
    <InputWrapper>
      <input
        ref={forwardRef}
        type="text"
        placeholder={placeholder || ''}
        onChange={handleTextChange}
        value={textInputValue}
        onFocus={onTextInputFocus}
        onBlur={onTextInputBlur}
      />
      {showTagSearchResults && (
        <SelectableTagResults
          query={activeQuery}
          isQuerying={isQuerying}
          results={selectableTags}
          onSelectTag={handleAddTag}
          enableCreateTag={enableCreateTag}
        />
      )}
    </InputWrapper>
  );
};
